import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { API } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

const FavContext = createContext(null);

export const FavoritesProvider = ({ children }) => {
  const { user } = useAuth();
  const [skus, setSkus] = useState([]);

  const refresh = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/favorites`);
      setSkus(data.skus);
    } catch { setSkus([]); }
  }, []);

  useEffect(() => {
    if (user) refresh();
    else setSkus([]);
  }, [user, refresh]);

  const isFav = useCallback((sku) => skus.includes(sku), [skus]);

  const toggle = useCallback(async (product) => {
    if (!user) {
      toast.info("Connectez-vous pour enregistrer vos favoris");
      return;
    }
    const sku = product.sku;
    if (skus.includes(sku)) {
      setSkus((p) => p.filter((s) => s !== sku));
      try { await axios.delete(`${API}/favorites/${sku}`); } catch { refresh(); }
    } else {
      setSkus((p) => [...p, sku]);
      try { await axios.post(`${API}/favorites/${sku}`); toast.success("Ajouté à vos favoris"); } catch { refresh(); }
    }
  }, [user, skus, refresh]);

  return (
    <FavContext.Provider value={{ skus, isFav, toggle, refresh }}>
      {children}
    </FavContext.Provider>
  );
};

export const useFavorites = () => useContext(FavContext);
